( function () {
    'use strict';
    e.bootstrap = e.bootstrap || {};
    e.bootstrap.carousel = {};
    e.bootstrap.carousel.init = function () {
        var jCarousel = jQuery( '.carousel' );
        if ( jCarousel.length > 0 ) {
            e.bootstrap.carousel.activateFirstItem( jCarousel );
            e.bootstrap.carousel.initCarouselNavigation( jCarousel );
            e.bootstrap.carousel.initAutoplay( jCarousel );
            e.bootstrap.carousel.bindTouchEvents( jCarousel );
        }
    };
    // Aktiver f&oslash;rste slide i alle bootstrap carousels
    e.bootstrap.carousel.activateFirstItem = function ( jCarousel ) {
        jCarousel.each( function () {
            var jThis = jQuery( this );
            if ( jThis.find( '.carousel-inner .active' ).length !== 1 ) {
                jThis.find( '.carousel-indicators li, .carousel-inner .item' ).filter( ':first-child' ).addClass( 'active' );
                var eCarouselOptions = {};
                if ( jThis.is( '[data-interval="false"]' ) === true ) {
                    eCarouselOptions.interval = false;
                }
                jThis.carousel( eCarouselOptions );
            }
        } );
    };
    e.bootstrap.carousel.bindTouchEvents = function ( jCarousel ) {
        jCarousel.find( '.carousel-inner' ).on( 'swipeleft', function () {
            jQuery( this ).closest( '.carousel' ).carousel( 'next' );
        } );
        jCarousel.find( '.carousel-inner' ).on( 'swiperight', function () {
            jQuery( this ).closest( '.carousel' ).carousel( 'prev' );
        } );
    };
    e.bootstrap.carousel.initCarouselNavigation = function ( jCarousel ) {
        jCarousel.each( function () {
            var jThis = jQuery( this ),
                jThisControls = jThis.find( '.carousel-control' ),
                jThisIndicators = jThis.find( '.carousel-indicators' );
            if ( jThis.find( '.carousel-inner .item' ).length === 1 ) {
                jThisControls.hide();
                jThisIndicators.hide();
            }
            if ( jThisIndicators.length !== 0 ) {
                jThisIndicators.find( 'li' ).each( function ( index ) {
                    jQuery( this ).attr( 'data-slide-to', index );
                } );
            }
            if ( jThis.is( '.e-carousel-content' ) === true ) {
                var jThisIndicatorItems = jThisIndicators.find( 'li' ).css( {
                    width: ( Math.round( 100 / jThisIndicators.find( 'li' ).length * 100 ) / 100 ) + '%'
                } );
                if ( jThis.is( '[data-interval="false"]' ) === true && screen.width >= 1024 ) {
                    jThis.on( 'slid', function () {
                        jThisIndicatorItems.removeClass( 'active' ).eq( jThis.find( '.carousel-inner .active' ).index() ).addClass( 'active' );
                    } );
                    jThisIndicatorItems.on( 'mouseenter', function () {
                        var jThis = jQuery( this );
                        setTimeout( function () {
                            jThis.trigger( 'click.carousel.data-api' );
                        }, 1 );
                    } );
                }
            }
            if ( jThis.is( '.e-carousel-compact' ) === true ) {
                var jThumbnails = jThis.find( 'li' ),
                    jThumbnailsStep = 0,
                    jThumbnailsInView = Math.round( jThis.find( '.js-e-carousel-compact-thumbs' ).width() / jThumbnails.outerWidth() ),
                    jThumbnailsCenter = Math.round( jThumbnailsInView / 2 ),
                    jThumbnailsMaxStep = jThumbnails.length - jThumbnailsInView;
                if ( jThumbnails.length < jThumbnailsInView ) {
                    jThis.find( '.js-e-carousel-compact-thumbs' ).remove();
                }
                else {
                    jThis.find( '.js-e-carousel-compact-thumbs .left' ).addClass( 'inactive' );
                    e.constant.jWindow.on( 'resize load', function () {
                        jThis.find( '.carousel-indicators' ).css( {
                            width: jThumbnails.length * ( jThumbnails.outerWidth() + 4 ),
                            height: jThumbnails.find( 'img' ).height()
                        } );
                    } );
                    jThis.find( '.js-e-carousel-compact-thumbs' ).find( 'li' ).each( function ( i ) {
                        i = i + 1;
                        jQuery( this ).data( 'item', i );
                    } );
                    jThis.find( '.js-e-carousel-compact-thumbs' ).find( 'li' ).on( 'click', function () {
                        if ( jQuery( this ).data( 'item' ) > jThumbnailsCenter ) {
                            jThumbnailsStep = jQuery( this ).data( 'item' ) - jThumbnailsCenter;
                            if ( jThumbnailsStep > jThumbnailsMaxStep ) {
                                jThumbnailsStep = jThumbnailsMaxStep;
                            }
                            jThumbnails.css( 'left', ( jThumbnailsStep * -jThumbnails.outerWidth() - 2 ) + 'px' );
                        }
                        if ( jQuery( this ).data( 'item' ) <= jThumbnailsCenter && jThumbnailsStep > 0 ) {
                            jThumbnailsStep = jQuery( this ).data( 'item' ) - jThumbnailsCenter;
                            if ( jThumbnailsStep < 0 ) {
                                jThumbnailsStep = 0;
                            }
                            jThumbnails.css( 'left', ( jThumbnailsStep * -jThumbnails.outerWidth() - 2 ) + 'px' );
                        }
                    } );
                    var jThumbnailSlideLast = jThis.find( '.js-e-carousel-compact-thumbs' ).find( 'li:last' ).data( 'item' );
                    jThis.find( '.carousel-control' ).on( 'click', function ( event ) {
                        event.preventDefault();
                        if ( jQuery( this ).hasClass( 'right' ) ) {
                            if ( jThis.find( '.carousel-indicators' ).find( 'li.active' ).data( 'item' ) === jThumbnailSlideLast ) {
                                jThumbnails.css( 'left', '0px' );
                                jThis.find( '.js-e-carousel-compact-thumbs' ).find( 'li:first' ).trigger( 'click' );
                            }
                            else {
                                jThis.find( '.carousel-indicators' ).find( 'li.active' ).next( 'li' ).trigger( 'click' );
                            }
                        }
                        else if ( jQuery( this ).hasClass( 'left' ) ) {
                            if ( jThis.find( '.carousel-indicators' ).find( 'li.active' ).data( 'item' ) === 1 ) {
                                jThumbnails.css( 'left', -( jThumbnailsMaxStep * jThumbnails.outerWidth() + 2 ) + 'px' );
                                jThis.find( '.js-e-carousel-compact-thumbs' ).find( 'li:last' ).trigger( 'click' );
                            }
                            else {
                                jThis.find( '.carousel-indicators' ).find( 'li.active' ).prev( 'li' ).trigger( 'click' );
                            }
                        }
                    } );
                    jThis.find( '.js-e-carousel-compact-thumbs .left' ).on( 'click', function () {
                        if ( jThumbnailsStep > 0 ) {
                            jThumbnailsStep -= jThumbnailsInView;
                            if ( jThumbnailsStep < 0 ) {
                                jThumbnailsStep = 0;
                            }
                            jThumbnails.css( 'left', ( jThumbnailsStep * -jThumbnails.outerWidth() - 2 ) + 'px' );
                        }
                    } );
                    jThis.find( '.js-e-carousel-compact-thumbs .right' ).on( 'click', function () {
                        if ( jThumbnailsStep < jThumbnailsMaxStep ) {
                            jThumbnailsStep += jThumbnailsInView;
                            if ( jThumbnailsStep > jThumbnailsMaxStep ) {
                                jThumbnailsStep = jThumbnailsMaxStep;
                            }
                            jThumbnails.css( 'left', -( jThumbnailsStep * jThumbnails.outerWidth() + 2 ) + 'px' );
                        }
                    } );
                    jThis.find( '.js-e-carousel-compact-thumbs, .js-e-carousel-compact-thumbs li' ).on( 'click', function () {
                        if ( jThumbnailsStep === jThumbnailsMaxStep ) {
                            jThis.find( '.js-e-carousel-compact-thumbs .right' ).addClass( 'inactive' );
                            jThis.find( '.js-e-carousel-compact-thumbs .left' ).removeClass( 'inactive' );
                        }
                        else if ( jThumbnailsStep < jThumbnailsMaxStep && jThumbnailsStep !== 0 ) {
                            jThis.find( '.js-e-carousel-compact-thumbs .right' ).removeClass( 'inactive' );
                            jThis.find( '.js-e-carousel-compact-thumbs .left' ).removeClass( 'inactive' );
                        }
                        else if ( jThumbnailsStep === 0 ) {
                            jThis.find( '.js-e-carousel-compact-thumbs .left' ).addClass( 'inactive' );
                            jThis.find( '.js-e-carousel-compact-thumbs .right' ).removeClass( 'inactive' );
                        }
                    } );
                }
            }
        } );
    };
    e.bootstrap.carousel.initAutoplay = function ( jCarousel ) {
        jCarousel.filter( '[data-autoplay="true"]' ).carousel( 'cycle' );
    };
}() );
